// extracted by mini-css-extract-plugin
export var headerCell = "_4v-1";
export var loadingSpinnerContainer = "_4v-4";
export var loadingStateCell = "_4v-5";
export var rowWrapper = "_4v-3";
export var standaloneTable = "_4v-6";
export var table = "_4v-0";
export var white = "_4v-2";